import { apiDaInscricao } from "../../../servicos/axios";

export interface CriarLocalPayload {
  Descricao: string;
  IdCidade: number;
  EhCidadeParceira: boolean;
  DataDeVigenciaInicial?: string | null;
  DataDeVigenciaFinal?: string | null;
}

export const criarLocal = async (payload: CriarLocalPayload) => {
  const response = await apiDaInscricao().post(
    "/LocalDeAtendimento/criar",
    payload
  );
  return response.data;
};
